<template>
    <div class="viewer" v-if="log">
        <collapse :active-index="0">
            <collapse-item :title="$t('xapi.log.api') + ' & ' + $t('xapi.log.method')">
                <p class="text-white">{{ log.api }} / {{ log.method }}</p>
            </collapse-item>
            <collapse-item :title="$t('xapi.log.status') + ' & ' + $t('xapi.log.message')">
                <p class="text-white">{{ log.data.response.status }} - {{ log.data.response.message }}</p>
            </collapse-item>
            <collapse-item :title="$t('xapi.log.params')" v-if="log.data.request.params">
                <json-viewer :data="log.data.request.params"></json-viewer>
            </collapse-item>
            <collapse-item :title="$t('xapi.log.headers')">
                <json-viewer :data="log.data.request.headers"></json-viewer>
            </collapse-item>
            <collapse-item :title="$t('xapi.log.content')" v-if="log.data.details.data">
                <json-viewer :data="log.data.details.data"></json-viewer>
            </collapse-item>
            <collapse-item :title="$t('xapi.log.errors')" v-if="log.data.details.errors">
                <json-viewer :data="log.data.details.errors"></json-viewer>
            </collapse-item>
        </collapse>
    </div>
</template>

<script>
    export default {
        props: ['log']
    }
</script>

<style scoped>

    .viewer >>> .card-collapse .card .card-header:after {
        content: "";
    }

</style>
